import React from "react";
import { Card } from "react-bootstrap";

const KpiCardSkeleton = ({ compact }) => (
   <Card className="card-one">
      <Card.Body style={{ padding: compact ? "0.6rem 0.75rem" : undefined }}>
         <div className="placeholder-glow">
            <span className="placeholder col-7 d-block mb-2" style={{ height: "12px" }}></span>
            <span className="placeholder col-5 d-block mb-2" style={{ height: compact ? "18px" : "24px" }}></span>
            <span className="placeholder col-4 d-block" style={{ height: "10px" }}></span>
         </div>
      </Card.Body>
   </Card>
);

const KpiCardError = ({ onRetry, compact }) => (
   <Card className="card-one">
      <Card.Body className="d-flex flex-column align-items-center justify-content-center text-center" style={{ minHeight: compact ? "75px" : "100px", padding: compact ? "0.6rem 0.75rem" : undefined }}>
         <i className="ri-error-warning-line text-danger mb-1" style={{ fontSize: compact ? "1.1rem" : "1.5rem" }}></i>
         <small className="text-secondary mb-1">Failed to load</small>
         {onRetry && (
            <small className="text-primary" style={{ cursor: "pointer" }} onClick={onRetry}>
               Retry
            </small>
         )}
      </Card.Body>
   </Card>
);

const KpiCard = ({ label, icon, value, percent, status, comparePeriod, isLoading, isError, onRetry, compact }) => {
   if (isLoading) return <KpiCardSkeleton compact={compact} />;
   if (isError) return <KpiCardError onRetry={onRetry} compact={compact} />;

   const isPositive = status === "up";
   const hasTrend = percent !== undefined && percent !== null && comparePeriod;

   return (
      <Card className="card-one">
         <Card.Body
            className="d-flex flex-column"
            style={{
               minHeight: compact ? "75px" : "100px",
               padding: compact ? "0.6rem 0.75rem" : undefined,
            }}
         >
            <Card.Title as="label" className="fw-medium mb-0" style={{ fontSize: compact ? "0.7rem" : undefined }}>{label}</Card.Title>

            <div className="d-flex align-items-center justify-content-between flex-grow-1">
               <i className={icon} style={{ fontSize: compact ? "1.1rem" : "1.5rem", color: "#506fd9" }}></i>
               <h3 className="card-value mb-0" style={{ fontSize: compact ? "1rem" : undefined }}>{value}</h3>
            </div>

            {hasTrend ? (
               <small style={{ fontSize: compact ? "0.65rem" : undefined }}>
                  <span className={"d-inline-flex text-" + (isPositive ? "success" : "danger")}>
                     {percent}% <i className={"ri-arrow-" + (isPositive ? "up" : "down") + "-line"}></i>
                  </span>{" "}
                  {comparePeriod}
               </small>
            ) : comparePeriod ? (
               <small className="text-secondary" style={{ fontSize: compact ? "0.65rem" : undefined }}>
                  {comparePeriod}
               </small>
            ) : (
               <small>&nbsp;</small>
            )}
         </Card.Body>
      </Card>
   );
};

export default KpiCard;
